var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailInactive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 28.193 21.432",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.818)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: "1.5px",
    stroke: "current",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M531.383,409.853l-20.251-.061",
    transform: "translate(-511.132 -402.58)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: "1.5px",
    stroke: "current",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M531.984,421.172v13.061H511.753V420.761",
    transform: "translate(-511.753 -413.551)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: "1.5px",
    stroke: "current",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M511.753,421.769l9.9,7.231,9.9-7.569",
    transform: "translate(-511.522 -413.91)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "current",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(12.375)"
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "#fff",
    y1: 6.621,
    x2: 6.62,
    transform: "translate(16.565 4.189)"
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "#fff",
    x2: 6.621,
    y2: 6.621,
    transform: "translate(16.565 4.189)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailInactive);
export default __webpack_public_path__ + "static/media/mail_inactive.a6b3e9dc26f7af5c001bc31503f74329.svg";
export { ForwardRef as ReactComponent };